import parser from "cron-parser";

export const parseCron = (cron: string | null) => {
  if (!cron) return {};

  cron = cron.replaceAll("?", "*");

  const cronExpression = parser.parseString(cron);
  const expressionsFields = cronExpression.expressions[0].fields;
  const { hour, minute } = expressionsFields;
  const dayOfMonth = cronExpression.expressions[0].fields
    .dayOfMonth as number[];

  const dayOfWeek = expressionsFields.dayOfWeek?.map((dow) =>
    dow === 0 ? 7 : dow,
  );

  const hours = hour.length > 1 ? hour[1] - hour[0] : hour[0];
  const minutes = minute.length > 1 ? null : minute[0];
  const daysOfWeek = dayOfWeek.length > 7 ? null : dayOfWeek;
  const daysOfMonth =
    dayOfMonth.length > 1 ? dayOfMonth[1] - dayOfMonth[0] : dayOfMonth[0];

  return { hours, minutes, daysOfWeek, daysOfMonth };
};
